import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { selectionPluginKey } from './selection-plugin-key';
import { isPseudoSelectionChanged } from './utils';
export var createSelectionPlugin = function createSelectionPlugin() {
  var isMouseDown = false;
  var selectionChangedDuringDrag = false;
  return new SafePlugin({
    key: selectionPluginKey,
    state: {
      init: function init(_, _state) {
        return {
          nonCursorSelectionChangeCount: 0
        };
      },
      apply: function apply(tr, pluginState, _oldEditorState) {
        var meta = tr.getMeta(selectionPluginKey);
        if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'incrementNonCursorSelectionChangeCount') {
          return _objectSpread(_objectSpread({}, pluginState), {}, {
            nonCursorSelectionChangeCount: pluginState.nonCursorSelectionChangeCount + 1
          });
        }
        return pluginState;
      }
    },
    appendTransaction: function appendTransaction(_transactions, oldState, newState) {
      var oldSel = oldState.selection;
      var newSel = newState.selection;
      var pseudoSelectionChanged = isPseudoSelectionChanged(oldState, newState);

      // Check for pseudo-selection changes first
      if (pseudoSelectionChanged) {
        // If pseudo-selection changed, always count as meaningful
        // unless we are dragging with mouse
        if (isMouseDown) {
          selectionChangedDuringDrag = true;
          return null;
        }
        return newState.tr.setMeta(selectionPluginKey, {
          action: 'incrementNonCursorSelectionChangeCount'
        });
      }

      // If no pseudo-selection change, check actual selection differences
      if (oldSel.eq(newSel)) {
        return null;
      }

      // If both are empty and no pseudo-change
      if (oldSel.empty && newSel.empty) {
        return null;
      }

      // If the mouse is currently down (e.g., during a drag), record that a change occurred
      // but do not increment the counter yet. The increment will happen when the mouse is released.
      if (isMouseDown) {
        selectionChangedDuringDrag = true;
        return null;
      }

      // If the mouse is not down, this change is considered final and should increment
      // the selection change count immediately.
      return newState.tr.setMeta(selectionPluginKey, {
        action: 'incrementNonCursorSelectionChangeCount'
      });
    },
    props: {
      handleDOMEvents: {
        mousedown: function mousedown(_view) {
          // When the mouse goes down, we start "dragging" mode.
          isMouseDown = true;
          selectionChangedDuringDrag = false;
          return false; // Returning false to allow other handlers
        },
        mouseup: function mouseup(view) {
          // When the mouse is released, if a selection change happened during dragging,
          // we increment the counter once.
          isMouseDown = false;
          if (selectionChangedDuringDrag) {
            var state = view.state,
              dispatch = view.dispatch;
            dispatch(state.tr.setMeta(selectionPluginKey, {
              action: 'incrementNonCursorSelectionChangeCount'
            }));
            selectionChangedDuringDrag = false;
          }
          return false; // Returning false to allow other handlers
        }
      }
    }
  });
};